export function getCr(cr?: string | null) {
	if (cr === '0' || !cr) return '—';

	const fractions: {[key: string]: string} = {
		'1/2': '½',
		'1/4': '¼',
		'1/8': '⅛',
	};
	return fractions[cr] ? fractions[cr] : cr;
}
